import template from './military.html';
import { STATES } from '../../../../../constants';
import '@updater-components/icon';
import './military.global.css';

const MESSAGES = {
  SUCCESS: `You're all set - we'll file your USPS mail forwarding form. It will take up to
  12 days for your mail to start arriving. If your move date is further in the future, we'll
  submit your form 12 days before your move.`,
  ERROR: 'Sorry. There was an error submitting your form. Please try again.',
};

class ForwardMailMilitaryController {
  $onInit() {
    this.dashboardSref = STATES.DASHBOARD;
  }
}

export const ForwardMailMilitaryComponent = {
  template,
  controller: ForwardMailMilitaryController,
};
